/**-----------------------------------------------------------------------------
 *                                    E2RH
 * -----------------------------------------------------------------------------
 *
 *  filename: setPAssword.js
 *
 *  author: Thomas CLERET (thomas.cleret@proton.me)
 *
 *  creation: 13/10/2025 - 18:04
 *
 *  description:
 *
 *  Copyright (c) 2025 E2RH
 * -----------------------------------------------------------------------------
 */

import * as React from 'react';
import { toast } from 'react-toastify';
import * as utils from '../utils/utils.tsx';

/**
 * Change the user's password
 * * @param {callback} onSetCurrentAction Callback for the setCurrentAction, used to
 * exit the setPassword menu when done
 */
export default function SetPassword({ onSetCurrentAction }) {
   const curPasswordInputId = "cur-password-input";
   const newPasswordInputId = "new-password-input";
   const [showCurrPassword, setShowCurrPassword] = React.useState(false);
   const [showNewPassword, setShowNewPassword] = React.useState(false);

   const setCurrentAction = React.useCallback(event => {
      onSetCurrentAction(event)
   }, [onSetCurrentAction]);

   /**
    * Get the current and new passwords from the page and forward them to the onNewPassword callback
    * @param event
    */
   async function handleSubmit(event) {
      const cur_password = document.getElementById(curPasswordInputId).value;
      const new_password = document.getElementById(newPasswordInputId).value;

      if (event) {
         event.preventDefault();
      }

      if (cur_password.trim() !== "" && new_password.trim() !== "") {
         try {
            await utils.apiClient.post("/setPasswd", { password: cur_password, new_password: new_password });
            toast.success("Change password success!");
            setCurrentAction(utils.MenuAction.Dashboard);
         }
         catch (error) {
            toast.error(error);
         }
      }
      else {
         toast.error("Invalid credentials");
      }
   }

   return (
      <div className="setPasswd_wrapper">
         <h3> Changement mot de passe </h3>
         <form className="login_form" onSubmit={handleSubmit}>
            {utils.passwordField("Mot de passe actuel", curPasswordInputId, showCurrPassword, setShowCurrPassword)}
            {utils.passwordField("Nouveau mot de passe", newPasswordInputId, showNewPassword, setShowNewPassword)}
            <div className="login_field w100">
               <button type="submit" >Changer mot de passe</button>
            </div>
         </form>
      </div>
   );
}
